// socket.js
import { io } from "socket.io-client";
import { socketPath, wsApi } from "../../urlConfig";

let socketInstance = null;

const getToken = () => {
    if (typeof window === "undefined") return "";
    return window.localStorage.getItem("token") || "";
};

const getSocketConfigKey = () => `${wsApi}/admin|${socketPath}`;

const clearGlobalSocket = () => {
    if (typeof window === "undefined") return;

    delete window.socket;
    delete window.__ADMIN_SOCKET__;
    delete window.__ADMIN_SOCKET_CONFIG_KEY__;
};

export const getSocket = () => {
    const socketConfigKey = getSocketConfigKey();

    if (
        socketInstance &&
        typeof window !== "undefined" &&
        window.__ADMIN_SOCKET_CONFIG_KEY__ &&
        window.__ADMIN_SOCKET_CONFIG_KEY__ !== socketConfigKey
    ) {
        socketInstance.disconnect();
        socketInstance = null;
        clearGlobalSocket();
    }

    if (!socketInstance) {
        const token = getToken();

        socketInstance = io(`${wsApi}/admin`, {
            transports: ["websocket", "polling"],
            path: socketPath,
            reconnection: true,
            reconnectionAttempts: Infinity,
            reconnectionDelay: 800,
            reconnectionDelayMax: 5000,
            timeout: 15000,
            withCredentials: false,
            autoConnect: Boolean(token),
            auth: {
                token: token || undefined,
            },
        });

        socketInstance.on("connect", () => {
            console.log("Admin socket connected:", {
                id: socketInstance.id,
                url: `${wsApi}/admin`,
                path: socketPath,
            });
        });

        socketInstance.on("connect_error", (error) => {
            console.warn(
                "Admin socket connect_error:",
                error?.message || error
            );
        });

        socketInstance.on("disconnect", (reason) => {
            console.log("Admin socket disconnected:", reason);
        });

        if (typeof window !== "undefined") {
            window.socket = socketInstance;
            window.__ADMIN_SOCKET__ = socketInstance;
            window.__ADMIN_SOCKET_CONFIG_KEY__ = socketConfigKey;
        }
    }

    return socketInstance;
};

export const refreshAdminSocketAuth = ({ forceReconnect = false } = {}) => {
    const socket = getSocket();
    const nextToken = getToken();
    const previousToken = String(socket.auth?.token || "");

    socket.auth = {
        ...(socket.auth || {}),
        token: nextToken || undefined,
    };

    if (!nextToken) {
        if (socket.connected || socket.active) {
            socket.disconnect();
        }
        return;
    }

    const tokenChanged = previousToken !== nextToken;

    if (socket.connected && !tokenChanged && !forceReconnect) {
        return;
    }

    if (socket.connected) {
        socket.disconnect();
    }

    socket.connect();
};

export const disconnectAdminSocket = () => {
    if (!socketInstance) return;

    socketInstance.auth = {
        ...(socketInstance.auth || {}),
        token: undefined,
    };

    socketInstance.disconnect();
};

export const socket = getSocket();
